import { getI18n as e } from "@editor/ui-utils";
//#endregion
//#region src/index.ts
var t = {
	messages: {
		en: {
			seoWhitelistApi: {
				createAlreadyExists: "The whitelisted domain cannot be created because another domain with this name already exists.",
				updateAlreadyExists: "The whitelisted domain cannot be updated because another domain with this name already exists.",
				created: "Domain created",
				updated: "Domain updated",
				notFound: "Domain not found",
				requiredFields: "The whitelisted domain cannot be saved because mandatory information is missing."
			},
			seoWhitelistList: {
				newButton: "New domain",
				name: "Search for URl",
				deleteSeoWhitelist: "Delete",
				dpAny: "All",
				brand: "Brand",
				loading: "Loading domains",
				headerLabel: "Domain",
				headerCreatedAt: "Creation date",
				headerChangedAt: "Last modified date",
				headerChangedBy: "Last changed by",
				dpEdit: "Edit",
				dpView: "View domain",
				messageDeleted: "Message deleted",
				errorOnDeleting: "Error deleting",
				createSeoWhitelist: "Create domain",
				bannerMessage: "The domains of this list will receive links with a follow attribute. Subdomains have to be added separately to the list in case they should receive follow links as well. Please only enter the name of the domain, without protocol or path parts (example.com , sub.example.com)."
			},
			seoWhitelist: {
				seoWhitelistLabel: "Whitelist domain",
				newSeoWhitelist: "New domain",
				messageDeleteSeoWhitelist: "Are you sure you want to remove this domain from the follow whitelist?",
				messageDeleteSeoWhitelistTitle: "Are you sure you want to remove this domain from the follow whitelist?",
				deleteSeoWhitelist: "Delete domain from whitelist",
				messageDeleted: "Domain deleted",
				errorOnDeleting: "Error deleting the domain",
				errorFailedLoadedSeoWhitelistWithId: "Error getting the domain",
				domainNameInvalid: "Invalid domain name"
			},
			seoWhitelistEdit: {
				label: "Domain",
				editSeoWhitelist: "Bearbeiten",
				messageSaved: "New domain saved",
				messageUpdated: "Domain updated",
				deleteButton: "Delete"
			}
		},
		de: {
			seoWhitelistApi: {
				createAlreadyExists: "Die Whitelist-Domain kann nicht erstellt werden, weil bereits eine Domain mit diesem Namen existiert.",
				updateAlreadyExists: "Die Whitelist-Domain kann nicht aktualisiert werden, weil bereits eine Domain mit diesem Namen existiert.",
				created: "Domain erstellt",
				updated: "Domain aktualisiert",
				notFound: "Domain nicht gefunden",
				requiredFields: "Die Whitelist-Domain kann nicht gespeichert werden, weil Pflichtinformationen fehlen."
			},
			seoWhitelistList: {
				newButton: "Neue Domain",
				name: "Suchen nach URL",
				deleteSeoWhitelist: "Löschen",
				dpAny: "Alle",
				brand: "Marke",
				loading: "Domains laden",
				headerLabel: "Domain",
				headerCreatedAt: "Erstellungsdatum",
				headerChangedAt: "Änderungsdatum (last modified)",
				headerChangedBy: "Zuletzt geändert von",
				dpEdit: "Bearbeiten",
				dpView: "Domain anzeigen",
				messageDeleted: "Nachricht gelöscht",
				errorOnDeleting: "Fehler beim Löschen",
				createSeoWhitelist: "Domain erstellen",
				bannerMessage: "Die hier eingetragenen Domains erhalten Links mit Follow-Attribut. Subdomains müssen separat in die Liste eingetragen werden, wenn sie ebenfalls Follow-Links erhalten sollen. Bitte nur den Namen der Domain eintragen, ohne Protokoll- oder Pfadteile (example.com, sub.example.com)."
			},
			seoWhitelist: {
				seoWhitelistLabel: "Whitelist-Domain",
				newSeoWhitelist: "Neue Domain",
				messageDeleteSeoWhitelist: "Willst du diese Domain wirklich aus der Follow-Whitelist entfernen?",
				messageDeleteSeoWhitelistTitle: "Willst du diese Domain wirklich aus der Follow-Whitelist entfernen?",
				deleteSeoWhitelist: "Domain aus Whitelist löschen",
				messageDeleted: "Domain gelöscht",
				errorOnDeleting: "Fehler beim Löschen der Domain",
				errorFailedLoadedSeoWhitelistWithId: "Fehler beim Abrufen der Domain",
				domainNameInvalid: "Ungültiger Domain-Name"
			},
			seoWhitelistEdit: {
				label: "Domain",
				editSeoWhitelist: "Bearbeiten",
				messageSaved: "Neue Domain gespeichert",
				messageUpdated: "Domain aktualisiert",
				deleteButton: "Löschen"
			}
		}
	},
	routes: [{
		path: "/seo-whitelist",
		children: [
			{
				path: "",
				name: "seo_whitelist-list",
				component: () => import("./seo-whitelist-list.view-CAs2VnCM.js"),
				meta: { requiredRight: "whitelists:navigate" }
			},
			{
				path: "new",
				name: "seo_whitelist-new",
				component: () => import("./seo-whitelist-edit.view-jw3TuwQb.js"),
				props: () => ({ title: e().t("seoWhitelist.newSeoWhitelist") }),
				meta: { requiredRight: ["whitelists:navigate"] }
			},
			{
				path: ":id",
				name: "seo_whitelist-detail",
				component: () => import("./seo-whitelist-edit.view-jw3TuwQb.js"),
				props: (t) => ({
					title: e().t("seoWhitelistEdit.editSeoWhitelist"),
					id: t.params.id,
					backRoute: "/seo-whitelist"
				}),
				meta: { requiredRight: ["whitelists:navigate"] }
			}
		]
	}]
};
//#endregion
export { t as seoWhitelistModule };

//# sourceMappingURL=index.es.js.map